/** Choices offered by the Settings forms. The API stores the keys (IANA zones, ISO codes). */

export const TIME_ZONES: [zone: string, label: string][] = [
  ["Pacific/Honolulu", "Hawaii Time (US)"],
  ["America/Anchorage", "Alaska Time (US)"],
  ["America/Los_Angeles", "Pacific Time (US)"],
  ["America/Denver", "Mountain Time (US)"],
  ["America/Chicago", "Central Time (US)"],
  ["America/New_York", "Eastern Time (US)"],
  ["America/Toronto", "Eastern Time (Canada)"],
  ["America/Sao_Paulo", "Brasília Time"],
  ["Europe/London", "UK Time (London)"],
  ["Europe/Dublin", "Irish Time (Dublin)"],
  ["Europe/Paris", "Central European Time (Paris)"],
  ["Europe/Berlin", "Central European Time (Berlin)"],
  ["Europe/Athens", "Eastern European Time (Athens)"],
  ["Africa/Lagos", "West Africa Time (Lagos)"],
  ["Africa/Johannesburg", "South Africa Time"],
  ["Asia/Dubai", "Gulf Time (Dubai)"],
  ["Asia/Karachi", "Pakistan Time"],
  ["Asia/Kolkata", "India Time"],
  ["Asia/Dhaka", "Bangladesh Time (Dhaka)"],
  ["Asia/Singapore", "Singapore Time"],
  ["Asia/Hong_Kong", "Hong Kong Time"],
  ["Asia/Tokyo", "Japan Time"],
  ["Australia/Perth", "Western Australia Time"],
  ["Australia/Sydney", "Eastern Australia Time (Sydney)"],
  ["Pacific/Auckland", "New Zealand Time"],
];

export const INDUSTRIES: [key: string, label: string][] = [
  ["florist_retail", "Florist / retail"],
  ["retail", "Shop / retail"],
  ["food_drink", "Restaurant, café or bar"],
  ["beauty_wellness", "Beauty & wellness"],
  ["health", "Health & clinics"],
  ["fitness", "Fitness & sport"],
  ["trades", "Trades & home services"],
  ["professional_services", "Professional services"],
  ["creative", "Creative & design"],
  ["events", "Events & weddings"],
  ["hospitality", "Hotels & travel"],
  ["education", "Education & tutoring"],
  ["property", "Property"],
  ["technology", "Technology"],
  ["nonprofit", "Charity & non-profit"],
  ["other", "Other"],
];

export const CURRENCIES: [code: string, label: string][] = [
  ["GBP", "GBP (£)"],
  ["USD", "USD ($)"],
  ["EUR", "EUR (€)"],
  ["CAD", "CAD ($)"],
  ["AUD", "AUD ($)"],
  ["NZD", "NZD ($)"],
  ["AED", "AED (د.إ)"],
  ["INR", "INR (₹)"],
  ["BDT", "BDT (৳)"],
  ["PKR", "PKR (₨)"],
  ["SGD", "SGD ($)"],
  ["ZAR", "ZAR (R)"],
  ["NGN", "NGN (₦)"],
  ["JPY", "JPY (¥)"],
];

/** WhatsApp number countries: ISO code and calling code. */
export const COUNTRIES: [iso: string, dial: string, name: string][] = [
  ["GB", "44", "United Kingdom"],
  ["IE", "353", "Ireland"],
  ["US", "1", "United States"],
  ["CA", "1", "Canada"],
  ["AU", "61", "Australia"],
  ["NZ", "64", "New Zealand"],
  ["FR", "33", "France"],
  ["DE", "49", "Germany"],
  ["ES", "34", "Spain"],
  ["IT", "39", "Italy"],
  ["NL", "31", "Netherlands"],
  ["PT", "351", "Portugal"],
  ["GR", "30", "Greece"],
  ["PL", "48", "Poland"],
  ["AE", "971", "United Arab Emirates"],
  ["SA", "966", "Saudi Arabia"],
  ["IN", "91", "India"],
  ["BD", "880", "Bangladesh"],
  ["PK", "92", "Pakistan"],
  ["SG", "65", "Singapore"],
  ["MY", "60", "Malaysia"],
  ["HK", "852", "Hong Kong"],
  ["JP", "81", "Japan"],
  ["ZA", "27", "South Africa"],
  ["NG", "234", "Nigeria"],
  ["KE", "254", "Kenya"],
  ["BR", "55", "Brazil"],
  ["MX", "52", "Mexico"],
];

/** "GB" → 🇬🇧 */
export function flag(iso: string): string {
  return String.fromCodePoint(...[...iso.toUpperCase()].map((c) => 0x1f1a5 + c.charCodeAt(0)));
}

/** A known label, or the zone itself ("Europe/Lisbon") for zones not in the list. */
export function zoneLabel(zone: string): string {
  return TIME_ZONES.find(([z]) => z === zone)?.[1] ?? zone.replace(/_/g, " ");
}
